/* unplugin-vue-components disabled */import { render } from "./CommunityView.vue?vue&type=template&id=1f84c1e0&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=1f84c1e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f84c1e0"]])

export default __exports__